import { ref, onMounted, onBeforeUnmount } from 'vue';
import { PatsnapCopilotUsageService } from '@analytics/patsnap-copilot/src/patsnap-copilot-usage-service';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';

export const DISABLE_CLASS_NAME = 'no_kf';

export function appendOverwriteThirdPartyCss() {
    try {
        const css = `
        body.${DISABLE_CLASS_NAME} #launcher{
            display: none!important;
        }
    `;
        const head = document.head || document.getElementsByTagName('head')[0];
        const style = document.createElement('style');

        style.type = 'text/css';
        style.id = 'appendThirdPartyCss';
        style.appendChild(document.createTextNode(css));
        head.appendChild(style);
    } catch (error) {

    }
}


export function useRemoveZendesk() {
    const useCopilotUsage = injectService<PatsnapCopilotUsageService>(PatsnapCopilotUsageService);
    appendOverwriteThirdPartyCss();
    const removeZendeskTool = () => {
        const body = document.querySelector('body');
        if (!body) return;
        body.classList.add(DISABLE_CLASS_NAME);

        return () => {
            body.classList.remove(DISABLE_CLASS_NAME);
        };
    };

    const removeZendesk = ref<ReturnType<typeof removeZendeskTool>>();

    onMounted(async () => {
        const usage = await useCopilotUsage.getUsage();
        if (usage.enabled) {
            removeZendesk.value = removeZendeskTool();
        }
        
    });

    onBeforeUnmount(() => {
        removeZendesk.value?.();
    });
}

